import {stringify} from 'qs'
import {format} from 'utils'
import request from 'company-management/utils/request'
import api from '../apis/company-management'

export async function companies(params) {
    return request(`${api.companies.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function agentInfo(payload) {
    return request(`${format(api.agentInfo.url, {id: payload.id})}`)
}

export async function updateAgentInfo(payload) {
    return request(`${format(api.updateAgentInfo.url, {id: payload.id})}`, {
        method: api.updateAgentInfo.type,
        body: payload.body,
    })
}

export async function weWorkSetting(params) {
    return request(`${api.weWorkSetting.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function updateWeWorkSetting(payload) {
    return request(api.updateWeWorkSetting.url, {
        method: api.updateWeWorkSetting.type,
        body: payload.body,
    })
}

export async function menuTree() {
    return request(api.menuTree.url)
}

export async function updateCompany(payload) {
    return request(`${format(api.updateCompany.url, {id: payload.id})}`, {
        method: api.updateCompany.type,
        body: payload.body,
    })
}

export async function updateCreator(payload) {
    return request(`${format(api.updateCreator.url, {id: payload.id})}`, {
        method: api.updateCreator.type,
        body: payload.body,
    })
}

export async function addCompany(payload) {
    return request(api.addCompany.url, {
        method: api.addCompany.type,
        body: payload.body,
    })
}
